import { routes as home } from '@/views/home'
import { routes as consultarElaboracao } from '@/views/elaboracao/consultar'
import { routes as manterElaboracao } from '@/views/elaboracao/manter'
import { routes as meus } from '@/views/meus'
import { routes as receber } from '@/views/receber'
import { routes as reservados } from '@/views/reservados'
import { routes as setor } from '@/views/setor'
import { routes as tramitados } from '@/views/tramitados'
import { routes as workArea } from '@/views/workArea'
import { routes as visualizadorProcesso } from '@/views/virtus/visualizadorProcesso'
import { routes as incluirDocumento } from '@/views/elaboracao/documento'
import { routes as tramite } from '@/views/elaboracao/tramite'
import { routes as apensar } from '@/views/apensar'
import { routes as volume } from '@/views/volume'
import { routes as buscaGeral } from '@/views/buscaGeral'
import { routes as anexar } from '@/views/anexar'
import { routes as legado } from '@/views/legado'
import { routes as interessados } from '@/views/interessados'
import { routes as caixaMensagem } from '@/views/caixaMensagem'
import { routes as inativarEstrutura } from '@/views/inativarEstrutura'

export default [
  ...consultarElaboracao,
  ...manterElaboracao,
  ...meus,
  ...home,
  ...receber,
  ...reservados,
  ...setor,
  ...tramitados,
  ...workArea,
  ...visualizadorProcesso,
  ...incluirDocumento,
  ...tramite,
  ...apensar,
  ...volume,
  ...buscaGeral,
  ...anexar,
  ...legado,
  ...interessados,
  ...caixaMensagem,
  ...inativarEstrutura
]
